/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Instructions/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Illustrations from './Illustrations/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Instructions({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content/Instructions"
  
}) {
  let isBefore = useIsBefore()
let imageCaptureQuestionValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureQuestion',
})
let imageCaptureQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'imageCapture',
path: 'questions',
})
let imageCaptureQuestionPromptValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureQuestion',
path: 'prompt',
})
let aggregateData = fromHelpers.label(imageCaptureQuestionValueData, imageCaptureQuestionsValueData, imageCaptureQuestionPromptValueData)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let imageCaptureQuestionInstructionsValueData = fromData.useDataValue({ viewPath,
context: 'imageCaptureQuestion',
path: 'instructions',
})
let dtTypographyFontsizeL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.l'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Instructions.Vertical"
  data-view-path={viewPath}
 style={{'--o-1-15yFl7': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Instructions.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 textTransform="uppercase"
 data="imageCaptureQuestion"
 data="imageCapture.questions"
 data="imageCaptureQuestion.prompt"
 aggregate="helpers.js label"
 text={aggregateData}
 marginBottom={dtSpaceS}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 whiteSpace="wrap"
 fontSize={dtTypographyFontsizeL}
 marginBottom={dtSpaceM}
 data="imageCaptureQuestion.instructions"
 text={imageCaptureQuestionInstructionsValueData}
/>
<Illustrations
  viewPath={`${viewPath}/Illustrations`}
/>
</div>
</div>
{children}
</React.Fragment>)
}